import React from 'react';
import {
  MenuList,
  MenuListItem,
} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { 
  KnowledgeMapDownloadOptions,
} from 'constants/knowledgeMap';
import messages from './messages';
import { Menu, MenuListItemText } from './styles';

const KnowledgeMapDownloadMenu = ({ openModalSelector }) => {
  const { TEMPLATE_DOWNLOAD , INFORMATION_DOWNLOAD } = KnowledgeMapDownloadOptions;
  
  const downloadMenuOptions = [
    TEMPLATE_DOWNLOAD,
    INFORMATION_DOWNLOAD,
  ];

  return (
    <Menu>
      <MenuList>
        {downloadMenuOptions.map((menuItemType) => (
          <MenuListItem
            key={menuItemType}
            onClick={() => openModalSelector(menuItemType)}
          >
            <MenuListItemText>
              {intl.formatMessage(messages[menuItemType])}
            </MenuListItemText>
          </MenuListItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default KnowledgeMapDownloadMenu;
